import { LoadingButton } from "@mui/lab";
import { Box, Button, Grid } from "@mui/material";
import styled from "styled-components";
import { FormField } from "../../../../Form/FormField";
import { FileUpload } from "../../../components/FileUpload";
import { CMSImage, CMSImageType } from "@client/models/CMS/cmsImage";
import { useSelector } from "react-redux";
import {
  UploadImageAction,
  getIsLoading,
} from "../../../store/reducers/cmsReducer";
import { store } from "../../../store";
import { t } from "i18next";

type LocalizedImageFormProps = {
  index: number;
  remove: (index: number) => void;
  file: File | undefined;
  setFile: (file: File) => void;
  assetId?: string;
  image: CMSImage;
  setFieldValue: (field: string, value: any) => void;
};

const LocalizedImageForm = ({
  index,
  remove,
  file,
  setFile,
  assetId,
  image,
  setFieldValue,
}: LocalizedImageFormProps) => {
  const isLoading = useSelector(getIsLoading);
  const VALID_FILE_TYPES = [
    "image/png",
    "image/jpeg",
    "image/jpg",
    "image/gif",
    "image/svg",
    "image/webp",
  ];

  const handleUpload = () => {
    if (file && assetId) {
      store.dispatch(UploadImageAction(assetId, file, index));
    }
  };

  return (
    <BorderContainer key={index}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <FormField
            name={`images[${index}].type`}
            label="Type"
            select
            options={Object.values(CMSImageType).map((val) => ({
              label: val,
              value: val,
            }))}
            placeholder="Type - eg: providerLogo..."
          />
        </Grid>
        <Grid item xs={6}>
          <FormField
            readOnly
            name={`images[${index}].url`}
            label="URL"
            placeholder="Url to image"
            hidden
          />
          <FormField
            readOnly
            name={`images[${index}].source`}
            label="Source"
            placeholder="Source to image"
            hidden
          />
        </Grid>
        <Grid item xs={6}>
          <FormField
            readOnly
            name={`images[${index}].width`}
            label="Width"
            placeholder="Image width"
          />
        </Grid>
        <Grid item xs={6}>
          <FormField
            readOnly
            name={`images[${index}].height`}
            label="Height"
            placeholder="Image height"
          />
        </Grid>
        <Grid item xs={4} />
        <Grid
          item
          xs={4}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {image.url ? (
            <Box>
              <img
                src={image.url}
                width={"100%"}
                onLoad={(e) => {
                  const target = e.target as HTMLImageElement;
                  setFieldValue(`images[${index}].width`, target.naturalWidth);
                  setFieldValue(
                    `images[${index}].height`,
                    target.naturalHeight
                  );
                }}
              />
            </Box>
          ) : (
            <Box
              sx={{ display: "flex", flexDirection: "column", width: "100%" }}
            >
              <FileUpload
                files={file ? [file] : []}
                onFileChange={(files: File[]) => {
                  setFile(files[0]);
                }}
                allowedFileTypes={VALID_FILE_TYPES}
              />
              <LoadingButton
                disabled={!file}
                color="primary"
                sx={{ mt: 1 }}
                variant="outlined"
                loading={isLoading}
                onClick={handleUpload}
              >
                {t("common.upload")}
              </LoadingButton>
            </Box>
          )}
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Button color="error" variant="outlined" onClick={() => remove(index)}>
          Remove
        </Button>
      </Grid>
    </BorderContainer>
  );
};

const BorderContainer = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
`;

export default LocalizedImageForm;
